module.exports = __webpack_public_path__ + "img/doctor 1.298a7888.svg";